import React, { useState } from "react";
import "./traselectagemodal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import TraAgeCard from "../TRAAgeCard";
import { getActiveEmployerObj } from "../../helpers/trautil";
import { ErrorMessages } from "../../atoms/ErrorMessages";
import NotFound from "../../atoms/NotFound";
import LoadingSpinner from "../../atoms/Loader";

const TRASelectageModal = (props) => {
  const { potItem } = props;
  const [age, setAge] = useState(potItem == null ? 75 : potItem.retirementAge);
  const [showError, setShowError] = useState(false);
  const [currentAge, setCurrentAge] = useState(null);

  const handleUpdateClick = () => {
    props.handleTraUpdateBtn(age);
  };

  return (
    <div className="tra-selectage-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-eighteen-px"
          className="cross-icon"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">
        {"Select your target retirement age"}
      </div>
      <div className="sub-text">
        {potItem ? (
          <p>{`Editing this will only affect your ${
            getActiveEmployerObj(potItem)?.employerName
          } pot.`}</p>
        ) : (
          <p>
            {"Editing this will make one consistent age across all your pots."}
          </p>
        )}
      </div>
      <div className={showError ? "mt-5 ms-3 me-3 mb-3" : "mt-5 ms-3 me-3"}>
        <TraAgeCard
          age={potItem ? potItem.retirementAge : 75}
          isUpdateEnable={true}
          isMultiplePot={true}
          description={
            potItem
              ? `You are editing your current target retirement age for ${
                  getActiveEmployerObj(potItem)?.employerName
                }`
              : `You are editing your current target retirement age for all pots`
          }
          doj={getActiveEmployerObj(potItem)?.startDateOfEmployment}
          getUpdatedAgeValue={(updateAge) => {
            setAge(updateAge);
          }}
          setShowError={setShowError}
          setCurrentAge={setCurrentAge}
          schemeData={props.schemeData}
        />
      </div>
      {showError && (
        <ErrorMessages
          text={`Your target retirement age cannot be in the past because your current age is ${currentAge}.`}
          className="investment-alert-message margin-rem"
        />
      )}
      <Row>
        <Col lg={12} xs={12} className={showError ? "" : "mt-4"}>
          <div
            className={showError ? "container-button" : "container-button mt-3"}
          >
            <div>
              <Buttons
                name="Back"
                className="secondary"
                handleClick={props.handleTraBackBtn}
              />
            </div>
            <div>
              <Buttons
                name="Update"
                className="primary"
                handleClick={() => {
                  handleUpdateClick();
                }}
              />
            </div>
          </div>
        </Col>
        {props.traFetching && <LoadingSpinner />}
      </Row>
      <Row className="mt-3">
        {props.error422 ? <NotFound err="ERROR_422" /> : ""}
      </Row>
    </div>
  );
};

export default TRASelectageModal;
